(function () {
    'use strict';

    angular.module("imApp").factory("domObjectsViewService", ['$ihttp', function ($ihttp) {
        let service = {
            getDomObjectsView: function (parms) {
                return $ihttp.post({
                    method: 3031,
                    parameters: parms || {}
                });
            },
            listTreeView: function (parms) {
                return $ihttp.post({
                    method: 3037,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
